import React, {useEffect} from 'react';
import {motion} from 'framer-motion';

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          className="bg-white p-10 md:p-16 rounded-[2rem] shadow-sm border border-slate-200"
        >
          <h1 className="text-5xl font-bold text-slate-900 mb-4 font-serif">Refund Policy</h1>
          <p className="text-base text-slate-500 mb-10 uppercase tracking-widest font-bold">Last Updated: January 2025</p>

          <div className="space-y-8 text-slate-700 font-light leading-relaxed text-lg md:text-xl">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">1. Overview</h2>
              <p>
                MyMD Weight Loss (<a href="https://joinmymd.com" className="text-amber-700 underline">joinmymd.com</a>) is committed to transparency regarding our refund and cancellation terms. Please read this policy carefully before enrolling.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">2. Program Fees Are Refundable — With One Exception</h2>
              <p className="mb-4">
                All program coaching and administrative fees are <strong className="text-slate-900 font-semibold">eligible for a full refund</strong> provided that a refund request is submitted <strong className="text-slate-900 font-semibold">before</strong> medication has been dispensed by the independent treating physician.
              </p>
              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5">
                <p className="text-amber-900 font-semibold mb-1">Important — No Refund After Medication Dispensed</p>
                <p className="text-amber-800 font-light text-base">
                  Once the independent physician has reviewed your case and medication has been dispensed or shipped, <strong className="font-semibold">no refund can be issued</strong> for any portion of program fees. This is because the clinical service has been rendered and the cost of the medication has been incurred on your behalf.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">3. How to Cancel Before Dispensing</h2>
              <p>
                To cancel your enrollment before your physician review is completed or before medication is dispensed, contact us as soon as possible at:
              </p>
              <ul className="list-none mt-4 space-y-1">
                <li><strong className="text-slate-900 font-semibold">Email:</strong> <a href="mailto:support@joinmymd.com" className="text-amber-700 underline">support@joinmymd.com</a></li>
                <li><strong className="text-slate-900 font-semibold">Phone:</strong> <a href="tel:2512352120" className="text-amber-700 underline">251-235-2120</a></li>
                <li><strong className="text-slate-900 font-semibold">Mail:</strong> MyMD Weight Loss, 7250 Pierson Dr, Mobile, AL 36619</li>
              </ul>
              <p className="mt-4">
                Approved refunds are processed within <strong className="text-slate-900 font-semibold">5–10 business days</strong> to the original payment method.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">4. Split Payment Plans</h2>
              <p>
                If you enrolled on the 2-payment plan and qualify for a refund, any payments already collected will be refunded and any remaining scheduled payments will be cancelled immediately upon approval.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">5. Questions</h2>
              <p>
                If you have any questions about this policy, please don't hesitate to reach out to our team at <a href="mailto:support@joinmymd.com" className="text-amber-700 underline">support@joinmymd.com</a> or call <a href="tel:2512352120" className="text-amber-700 underline">251-235-2120</a>.
              </p>
            </section>

            <section className="bg-stone-50 border border-stone-200 rounded-2xl p-6">
              <p className="text-base text-stone-600 font-light">
                <strong className="font-semibold text-stone-800">Independent Clinical Entity Notice:</strong> JoinMyMD is a wellness coaching and administrative service provider. Medical evaluations and prescriptions are conducted by independent, board-certified healthcare professionals licensed in your state. Refund terms above apply to program coaching and administrative fees only.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RefundPolicy;